export default __webpack_public_path__ + "static/media/cafe-creme-logo.995e0fae.png";